import Ladda from "ladda";
import "ladda/dist/ladda-themeless.min.css";

export default {
  components: { Ladda },
  data() {
    return {
      forms: [
        'login_form',
        'forgot_password_form',
        'password_reset_form',
        'verify_email_form',
        'two_factor_form',
      ],
      redirect_url: window.redirect_url,
      two_factor_required: window.two_factor_required,
      user_uuid: window.user_uuid,
      error: null,
      submitting: false,
      success: null,
      current_ladda: null,
    };
  },
  mounted() {
    EventBus.$on('new_token', (payload) => {
      window.csrfToken = payload;
    });
  },
  computed: {
    csrf() {
      return window.csrfToken;
    },
  },
  methods: {
    laddaButton(button_id) {
      this.current_ladda = Ladda.create(document.querySelector(`#${button_id}`));
      this.current_ladda.start();
    },
    unLaddaButton(button_id) {
      if (this.current_ladda) {
        this.current_ladda.stop();
      } else {
        this.current_ladda = Ladda.get(document.querySelector(`#${button_id}`));
        this.current_ladda.stop();
      }
      this.current_ladda = null;
    },
    showForm(form_name) {
      _.forEach(this.forms, (form) => {
        $(`#${form}`).hide();
      });

      $(`#${form_name}`).show();
    },
    setSuccess(message) {
      this.success = message;
      this.error = null;
    },
    setError(message) {
      this.error = message;
      this.success = null;
    },
  },
};
